import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../assets/en_devel.json';
import { VisibleFeedbackComponent } from './visible-feedback/visible-feedback.component';
import { DelayedFeedbackComponent } from './delayed-feedback/delayed-feedback.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FeedbackService } from './feedback.service';

@NgModule({
  declarations: [FeedbackDialogComponent, VisibleFeedbackComponent, DelayedFeedbackComponent],
  exports: [VisibleFeedbackComponent, DelayedFeedbackComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/feedback',
      baseTranslation: baseTranslation,
    }),
    MatCardModule,
    MatProgressSpinnerModule,
  ],
  providers: [FeedbackService],
})
export class FeedbackModule {}
